import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
  CssBaseline,
  Box,
  CircularProgress,
  ListItemAvatar,
  Badge,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import {
  AccountCircle,
  AccountCircleTwoTone,
  HistoryEdu,
  Store,
} from "@mui/icons-material";
import { LoginContext } from "./LoginPage/LoginContext";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Person2Icon from "@mui/icons-material/Person2";
import Divider from "@mui/material/Divider";
import LogoutIcon from "@mui/icons-material/Logout";
import ib_logo from "../icons/IB_logo.png";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SpeedIcon from "@mui/icons-material/Speed";
import GroupIcon from "@mui/icons-material/Group";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import Tooltip from "@mui/material/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import leadFormStyles from "./Leads Page/leadFormStyles.module.css";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { logout } from "../Actions/LoginAction";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import NotificationComponent from './Notification/NotificationComponent';
import axios from "axios";
import {
  ATTENDANCE_OUT,
  GET_LEAD_BY_BDM_API,
  GET_NOTIFICATION,
  UPDATE_NOTIFICATION,
} from "../constants";
import dayjs from "dayjs";
import NotificationsIcon from "@mui/icons-material/Notifications";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import {
  BookCheck,
  Calendar1,
  PhoneCall,
  CircleUserRound,
  File,
  FileDown,
  ListChecks,
  Palmtree,
  Users,
} from "lucide-react";
import RouteIcon from "@mui/icons-material/Route";
import BottomNavigationComponent from "./BottomNavigationComponent";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Cookies from "js-cookie";
import moment from "moment";

const MobileMainComponent = ({ logout }) => {
  const theme = useTheme();

  const [drawerOpen, setDrawerOpen] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [alertTitle, setalertTitle] = useState("");

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleprofileNavigate = () => {
    navigate("/profile");
    setAnchorEl(null);
  };

  const [openDialog, setOpenDialog] = useState(false);

  const attendance = localStorage.getItem("attendance");
  const outTime = attendance ? JSON.parse(attendance)?.outTime : null;

  const handleAttendanceOut = () => {
    setOpenDialog(true); // Open the confirmation dialog
    handleClose(); // Close the menu
  };

  const confirmAttendanceOut = () => {
    setOpenDialog(false); // Close the dialog
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const payload = {
          bdmId: localStorage.getItem("username"),
          attendanceId:
            JSON.parse(localStorage.getItem("userData")).todayAttendance
              ?.attendanceId ||
            JSON.parse(localStorage.getItem("attendance")).attendanceId,
          latitude: latitude,
          longitude: longitude,
        };
        setLoading(true);

        try {
          const response = await axios.post(`${ATTENDANCE_OUT}`, payload);
          const { message } = response.data;

          setOpenSnackbar(true);
          setSeverity("success");
          setMessage(message);

          setTimeout(() => {
            handleLogout();
          }, 1000); // Delay for 1 seconds
        } catch (error) {
          console.error("Error submitting actions:", error);
          setOpenSnackbar(true);
          setSeverity("error");
          setMessage(error.response.data.message);
        } finally {
          setLoading(false);
        }
      },
      (error) => {
        console.error("Error fetching location:", error);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };

  const cancelAttendanceOut = () => {
    setOpenDialog(false); // Close the dialog without proceeding
  };

  const handleLogout = () => {
    localStorage.clear();
    // logout();
    Cookies.remove("authToken", { path: "/" });
    navigate("/");
    // navigate(0);
  };

  const [bdmAssignedPage, setBdmAssignedPage] = useState(false);
  const [bdmToDoPage, setBdmToDoPage] = useState(false);

  const [leadpage, setLeadPage] = useState(false);
  const [supPage, setSupPage] = useState(false);
  const [auPage, setAuPage] = useState(false);

  const storedRole = localStorage.getItem("empRole");

  useEffect(() => {
    if (storedRole == 2) {
      setBdmAssignedPage(true);
      setBdmToDoPage(true);
    }
    if (storedRole == 1) {
      setLeadPage(true);
    }
    if (storedRole == 5) {
      setSupPage(true);
    }
    if (storedRole == 100) {
      setAuPage(true);
    }
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:900px)");

  const path = window.location.pathname;

  const handleDrawerClose = () => {
    if (isMobile) {
      setDrawerOpen(false);
    }
  };

  const [menuEl, setMenuEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleNotificationOpen = (event) => {
    setMenuEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setMenuEl(null);
  };

  const fetchUnreadNotification = async () => {
    try {
      if (localStorage.getItem("empRole") !== "6") return;

      const response = await axios.get(
        `${GET_NOTIFICATION}?employeeId=${localStorage.getItem(
          "username"
        )}&readStatus=unread`
      );

      setNotifications(response.data.notifications); // Set only unread notifications
    } catch (error) {
      console.error("Error fetching notifications", error);
    }
  };

  useEffect(() => {
    fetchUnreadNotification(); // Initial call on mount

    const interval = setInterval(() => {
      fetchUnreadNotification();
    }, 300000); // Runs every 5 minutes (300,000 ms)

    return () => clearInterval(interval); // Cleanup function to avoid memory leaks
  }, []);

  const handleClearAllNotifications = () => {};

  // useEffect(() => {
  //   const empId = localStorage.getItem("username");
  //   setLoading(true);
  //   axios
  //     .get(`${GET_LEAD_BY_BDM_API}/${empId}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //       },
  //     })
  //     .then((response) => {
  //       const { leads } = response.data;
  //       // setNotifications(leads);
  //       handleNotification(leads);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching notifications:", error);
  //     });
  // }, []);

  const handleNotificationClick = async (notification) => {
    try {
      const payload = {
        notificationId: notification.id,
      };
      // Call the API to mark the notification as read
      const response = await axios.put(`${UPDATE_NOTIFICATION}`, payload);
      fetchUnreadNotification();
    } catch (error) {
      console.error("Error marking notification as read", error);
    }

    navigate("/bdmDetails/converted/view", {
      state: {
        MobNo: notification.leadDetail?.MobileNo,
        leadId: notification.leadDetailId,
      },
    });
    handleNotificationClose();
  };

  const DrawerList = (
    <>
      {/* <Toolbar /> */}
      <Box sx={{ overflow: "hidden", backgroundColor: "#fff", height: "100%" }}>
        <List>
          {!(storedRole === 6 || storedRole === 7) && (
            <ListItem
              key={"dashboard"}
              button
              component={RouterLink}
              to="/dashboard"
              disablePadding
              className={
                path == "/dashboard"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path == "/dashboard" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Dashboard" arrow>
                  <SpeedIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Dashboard"}
                sx={{ opacity: 1 }}
                className={``}
              />
            </ListItem>
          )}

          {(leadpage || localStorage.getItem("empRole") == 3) && (
            <ListItem
              key={"lead"}
              disablePadding
              button
              component={RouterLink}
              className={
                path == "/lead"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              to="/lead"
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={path == "/lead" ? `${leadFormStyles.active}` : ``}
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Lead" arrow>
                  <GroupIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={"Lead"} sx={{ opacity: 1 }} />
            </ListItem>
          )}

          {bdmAssignedPage && (
            <ListItem
              key={"bdm_assigned"}
              disablePadding
              button
              component={RouterLink}
              to="/bdmAssigned"
              className={
                path == "/bdmAssigned"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="BDM Assigned" arrow>
                  <GroupIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={"BDM Assigned"} sx={{ opacity: 1 }} />
            </ListItem>
          )}

          {
            <>
              {(bdmToDoPage || storedRole === "3") && (
                <ListItem
                  key={"bdm_todo"}
                  disablePadding
                  button
                  component={RouterLink}
                  to="/bdmtodo"
                  className={
                    path === "/bdmtodo"
                      ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                      : ""
                  }
                  sx={{
                    display: "flex",
                    minHeight: 48,
                    justifyContent: "center",
                    px: 2.5,
                  }}
                  onClick={handleDrawerClose}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: 3,
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title="Today Tasks" arrow>
                      <BookCheck />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={"Today Tasks"} sx={{ opacity: 1 }} />
                </ListItem>
              )}
            </>
          }

          {storedRole == 6 && (
            <ListItem
              key={"ho_approval"}
              disablePadding
              button
              component={RouterLink}
              className={
                path == "/estimateGeneration"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              to="/estimateGeneration"
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path == "/estimateGeneration"
                    ? `${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Estimate List" arrow>
                  <DomainVerificationIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"P-Card Estimation Requested"}
                sx={{ opacity: 1 }}
              />
            </ListItem>
          )}

          {storedRole == 101 && (
            <ListItem
              key={"auditMaster"}
              disablePadding
              button
              component={RouterLink}
              className={
                path == "/auditMaster"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              to="/auditMaster"
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path == "/auditMaster" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Audit Lead" arrow>
                  <VerifiedUserIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={"Audit Master"} sx={{ opacity: 1 }} />
            </ListItem>
          )}

          {/* {bdmAssignedPage && <ListItem key={'meetingPage'} 
                  disablePadding  
                  button component={RouterLink} 
                  to="/meetingPage"
                  className={path == '/meetingPage' ? `${leadFormStyles.active_back} ${leadFormStyles.active}` : ``}
                  sx={{ display: 'flex',
                    minHeight: 48,
                    justifyContent: 'center',
                    px: 2.5,
                   }}
                   onClick={handleDrawerClose}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: 2,
                        justifyContent: 'center',
                      }}
                    >
                      <Tooltip title="Meeting" arrow>
                      <GroupIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary={'Meeting'} sx={{ opacity: 1  }} />
                </ListItem>} */}

          {supPage && (
            <ListItem
              key={"lead_master"}
              disablePadding
              button
              component={RouterLink}
              to="/leadMaster"
              className={
                path == "/leadMaster"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Leads Master" arrow>
                  <PersonAddAltIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={"Leads Master"} sx={{ opacity: 1 }} />
            </ListItem>
          )}

          {storedRole === "5" && (
            <>
              <ListItem
                key={"lead_action"}
                disablePadding
                button
                component={RouterLink}
                to="/leadAction"
                className={
                  path === "/leadAction"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
                onClick={handleDrawerClose}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 3,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Action by BDM" arrow>
                    <DashboardIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={"Action by BDM"} sx={{ opacity: 1 }} />
              </ListItem>
            </>
          )}

          {storedRole === "5" && (
            <>
              <ListItem
                key={"bdm_report"}
                disablePadding
                button
                component={RouterLink}
                to="/bdmReport"
                className={
                  path === "/bdmReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
                onClick={handleDrawerClose}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 3,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="BDM Report" arrow>
                    <ListChecks />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={"BDM Report"} sx={{ opacity: 1 }} />
              </ListItem>
            </>
          )}

          {storedRole === "5" && (
            <>
              <ListItem
                key={"qr_report"}
                disablePadding
                button
                component={RouterLink}
                to="/qrReport"
                className={
                  path === "/qrReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
                onClick={handleDrawerClose}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 3,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="QR Enquiry Report" arrow>
                    <QrCodeIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"QR Enquiry Report"}
                  sx={{ opacity: 1 }}
                />
              </ListItem>
            </>
          )}
          {storedRole === "5" && (
            <>
              <ListItem
                key={"All Agent Calls"}
                disablePadding
                button
                component={RouterLink}
                to="/incoming-outgoing-call"
                className={
                  path === "/incoming-outgoing-call"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
                onClick={handleDrawerClose}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 3,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="All Agent Calls" arrow>
                    <PhoneCall/>
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"All Agent Calls"}
                  sx={{ opacity: 1 }}
                />
              </ListItem>
            </>
          )}

          {auPage && (
            <ListItem
              key={"audit_lead"}
              disablePadding
              button
              component={RouterLink}
              className={
                path == "/auditLead"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              to="/auditLead"
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path == "/auditLead" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Audit Lead" arrow>
                  <VerifiedUserIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={"Audit Lead"} sx={{ opacity: 1 }} />
            </ListItem>
          )}

          {(storedRole !== "1" && storedRole !== "500") && (
            <>
              {(storedRole === "2" || storedRole === "3") ? (
                <>
                  <ListItem
                    key={"attendance_report"}
                    disablePadding
                    button
                    component={RouterLink}
                    to="/attendanceReport/details"
                    className={
                      path === "/attendanceReport/details"
                        ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                        : ``
                    }
                    sx={{
                      display: "flex",
                      minHeight: 48,
                      justifyContent: "center",
                      px: 2.5,
                    }}
                    onClick={handleDrawerClose}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: 3,
                        justifyContent: "center",
                      }}
                    >
                      <Tooltip title="Travel Report" arrow>
                        <Calendar1 />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText
                      primary={"Travel Report"}
                      sx={{ opacity: 1 }}
                    />
                  </ListItem>
                </>
              ) : (
                <ListItem
                  key={"attendance_report"}
                  disablePadding
                  button
                  component={RouterLink}
                  to="/attendanceReport"
                  className={
                    path === "/attendanceReport"
                      ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                      : ``
                  }
                  sx={{
                    display: "flex",
                    minHeight: 48,
                    justifyContent: "center",
                    px: 2.5,
                  }}
                  onClick={handleDrawerClose}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: 3,
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title="Travel Report" arrow>
                      <Calendar1 />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={"Travel Report"} sx={{ opacity: 1 }} />
                </ListItem>
              )}
            </>
          )}

          {(storedRole !== "1" && storedRole != "500") && (
            <>
              <ListItem
                key={"leave_report"}
                disablePadding
                button
                component={RouterLink}
                to="/leaveReport"
                className={
                  path === "/leaveReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
                onClick={handleDrawerClose}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 3,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Leave Report" arrow>
                    <CircleUserRound />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={"Leave Report"} sx={{ opacity: 1 }} />
              </ListItem>
            </>
          )}

          {storedRole === "1" && (
            <>
              <ListItem
                key={"enquiry_data"}
                disablePadding
                button
                component={RouterLink}
                to="/enquiry_data"
                className={
                  path === "/enquiry_data"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 3,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="QR Enquiry Leads" arrow>
                    <QrCodeIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"QR Enquiry Leads"}
                  sx={{ opacity: 1 }}
                />
              </ListItem>
            </>
          )}

          {(storedRole === "2" || storedRole === "3") && (
            <>
              <ListItem
                key={"groupMeeting"}
                disablePadding
                button
                component={RouterLink}
                to="/groupMeeting"
                className={
                  path === "/groupMeeting"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
                onClick={handleDrawerClose}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 3,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Group Meeting" arrow>
                    <Users />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={"Group Meeting"} sx={{ opacity: 1 }} />
              </ListItem>
            </>
          )}

          {(storedRole === "7" || storedRole === "5") && (
            <ListItem
              key={"hrReport"}
              button
              component={RouterLink}
              to="/hrReport"
              disablePadding
              className={
                path == "/hrReport"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path == "/hrReport" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="HR Report" arrow>
                  <FileDown />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"HR Report"}
                sx={{ opacity: 1 }}
                className={``}
              />
            </ListItem>
          )}

          {storedRole === "2" && (
            <ListItem
              key={"monthlyReport"}
              button
              component={RouterLink}
              to="/monthlyReport"
              disablePadding
              className={
                path == "/monthlyReport"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path == "/monthlyReport" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Monthly Attendance Report" arrow>
                  <File />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Monthly Attendance Report"}
                sx={{ opacity: 1 }}
                className={``}
              />
            </ListItem>
          )}

          {storedRole === "3" && (
            <ListItem
              key={"teamTravelReport"}
              disablePadding
              button
              component={RouterLink}
              to="/teamTravelReport"
              className={
                path === "/teamTravelReport"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path === "/teamTravelReport" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Team Travel Report" arrow>
                  <Users />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Team Travel Report"}
                sx={{ opacity: 1 }}
              />
            </ListItem>
          )}

          {storedRole === "3" && (
            <ListItem
              key={"bdmTaskReport"}
              disablePadding
              button
              component={RouterLink}
              to="/bdmTaskReport"
              className={
                path === "/bdmTaskReport"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={handleDrawerClose}
            >
              <ListItemIcon
                className={
                  path === "/bdmTaskReport" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="BDM Task Report" arrow>
                  <Users />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"BDM Task Report"}
                sx={{ opacity: 1 }}
              />
            </ListItem>
          )}

          {/* {storedRole === "2" && (
            <>
              <ListItem
                key={"attendance_report"}
                disablePadding
                button
                component={RouterLink}
                to="/attendanceReport"
                className={
                  path === "/attendanceReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr:  3 ,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Attendance Report" arrow>
                    <Calendar1 />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Attendance Report"}
                  sx={{ opacity:  1  }}
                />
              </ListItem>
            </>
          )} */}

          {/* <ListItem key={'hot_dis'} 
                  disablePadding 
                  button component={RouterLink} 
                  to="/hotDisposition"
                  sx={{ display: 'flex',
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                   }}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <Tooltip title="Hot Disposition Summary" arrow>
                      <AssessmentIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary={'Hot Disposition Summary'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItem> */}

          {/* <ListItem key={'warm_dis'} 
                disablePadding 
                button component={RouterLink} 
                  to="/warmDisposition"
                  sx={{ display: 'flex',
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                   }}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <Tooltip title="Warm Disposition Summary" arrow>
                      <AssessmentIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary={'Warm Disposition Summary'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItem> */}

          {/* <ListItem key={'history'} 
                disablePadding 
                button component={RouterLink} 
                  // to=""
                  sx={{ display: 'flex',
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                   }}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <Tooltip title="History" arrow>
                      <HistoryEdu />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary={'History'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItem> */}
          {/* {storedRole === "2" && (
            <>
              <ListItem
                key={"travel_report"}
                disablePadding
                button
                component={RouterLink}
                to="/travelReport"
                className={
                  path === "/travelReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr:  3 ,
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Travel Report" arrow>
                    <RouteIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Travel Report"}
                  sx={{ opacity: 1 }}
                />
              </ListItem>
            </>
          )} */}
        </List>
        <Box
          sx={{
            position: "absolute",
            bottom: 16,
            width: "100%",
            paddingLeft: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary" align="center">
            Version 1.12.0
          </Typography>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>

            <img
              src={ib_logo}
              loading="lazy"
              alt="onCall"
              className={`w-10`}
              style={{ marginLeft: "-18px" }}
            />
            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: isMobile ? 1 : 2,
                }}
              >
                {localStorage.getItem("empRole") === "6" && (
                  <>
                    {/* Notification Bell Icon */}
                    <IconButton
                      color="inherit"
                      onClick={handleNotificationOpen}
                      sx={{ padding: isMobile ? "5px" : "8px" }}
                    >
                      <Badge
                        badgeContent={unreadCount}
                        color="error"
                        sx={{
                          "& .MuiBadge-badge": {
                            fontSize: isMobile ? "10px" : "12px",
                            minWidth: isMobile ? "15px" : "18px",
                            height: isMobile ? "15px" : "18px",
                          },
                        }}
                      >
                        <NotificationsIcon
                          sx={{ fontSize: isMobile ? "1.5rem" : "2rem" }}
                        />
                      </Badge>
                    </IconButton>

                    {/* Notification Menu */}
                    <Menu
                      anchorEl={menuEl}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      open={Boolean(menuEl)}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      onClose={handleNotificationClose}
                      PaperProps={{
                        elevation: 3,
                        sx: {
                          width: isMobile
                            ? "250px"
                            : isTablet
                            ? "280px"
                            : "320px",
                          maxHeight: "300px",
                          overflowY: "auto",
                          borderRadius: "10px",
                          mt: 1.5,
                          boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                          position: "relative",
                          zIndex: 1302,
                          "&::before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: -5, // Positions the arrow slightly above the menu
                            right: 15,
                            width: 10,
                            height: 10,
                            backgroundColor: "background.paper",
                            transform: "rotate(45deg)",
                            zIndex: 1303,
                            boxShadow: "-1px -1px 3px rgba(0,0,0,0.1)", // Subtle shadow for realism
                          },
                        },
                      }}
                    >
                      {notifications.length > 0 ? (
                        <>
                          {/* <MenuItem onClick={handleClearAllNotifications}>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: "bold",
                                textAlign: "center",
                                width: "100%",
                                fontSize: isMobile ? "0.8rem" : "1rem",
                                color: "primary.main",
                                "&:hover": { backgroundColor: "action.hover" },
                              }}
                            >
                              Clear All Notifications
                            </Typography>
                          </MenuItem>
                          <Divider /> */}

                          <Box sx={{ maxHeight: 250, overflowY: "auto" }}>
                            {notifications.map((notification) => (
                              <Box
                                key={notification.id}
                                sx={{
                                  bgcolor: notification.isRead
                                    ? "inherit"
                                    : "rgba(0, 0, 255, 0.1)",
                                  transition: "all 0.3s ease",
                                  "&:hover": { bgcolor: "action.hover" },
                                }}
                              >
                                <MenuItem
                                  onClick={() => {
                                    handleNotificationClick(notification);
                                  }}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    whiteSpace: "normal", // Allows text wrapping
                                    overflow: "hidden",
                                    wordBreak: "break-word", // Ensures long words break properly
                                  }}
                                >
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      fontWeight: notification.isRead
                                        ? "normal"
                                        : "bold",
                                      fontSize: isMobile ? "0.85rem" : "1rem",
                                    }}
                                  >
                                    Document Upload
                                  </Typography>

                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: isMobile ? "0.75rem" : "0.9rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    {notification.text}
                                  </Typography>

                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    sx={{
                                      fontSize: isMobile ? "0.7rem" : "0.8rem",
                                    }}
                                  >
                                    {moment(notification.createdAt).fromNow()}
                                  </Typography>
                                </MenuItem>
                                <Divider />
                              </Box>
                            ))}
                          </Box>
                        </>
                      ) : (
                        <MenuItem disabled>
                          <Typography
                            variant="body1"
                            sx={{
                              textAlign: "center",
                              width: "100%",
                              fontSize: isMobile ? "0.9rem" : "1rem",
                            }}
                          >
                            No Notifications
                          </Typography>
                        </MenuItem>
                      )}
                    </Menu>
                  </>
                )}

                      {localStorage.getItem("empRole") === "2" && (
                                  <NotificationComponent/>
                            )}
                               {localStorage.getItem("empRole") === "3" && (
                                  <NotificationComponent/>
                            )}

              </Box>

              <IconButton onClick={handleClick} color="inherit">
                {/* <Avatar > */}
                <AccountCircleTwoTone sx={{ fontSize: "2.5rem !important" }} />
                {/* <div className={`flex-row ml-1`}>
          <p style={{fontSize: '1rem', textTransform: 'capitalize'}}>{JSON.parse(localStorage.getItem('userData')).EmployeeName}</p>
          <p style={{fontSize: '0.8rem', textAlign: 'left'}}>{JSON.parse(localStorage.getItem('userData')).EmployeeRole == 1 ? 'CSE' : (JSON.parse(localStorage.getItem('userData')).EmployeeRole == 5 ? 'Supervisor' : 'BDM')}</p>
          </div> */}
                <ExpandMoreIcon />
                {/* </Avatar> */}
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className={`w-100`}
              >
                <MenuItem onClick={handleprofileNavigate}>
                  <AccountCircle className={`mr-2`} />
                  Profile
                </MenuItem>
                {(localStorage.getItem("empRole") === "2" ||
                  localStorage.getItem("empRole") === "3" || localStorage.getItem("empRole") === "500") && (
                  <MenuItem
                    onClick={handleAttendanceOut}
                    disabled={!attendance || outTime !== null}
                  >
                    <TimerOffIcon className="mr-2" />
                    Attendance Out
                  </MenuItem>
                )}
                <Divider />
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon className={`mr-2`} />
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          variant={"temporary"}
          open={drawerOpen}
          onClose={handleDrawerToggle}
          sx={{
            width: 180,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: 250,
              boxSizing: "border-box",
            },
          }}
        >
          <Toolbar />
          {DrawerList}
        </Drawer>
      </Box>

      {(storedRole === "2" || storedRole === "3" || storedRole === "5" || storedRole === "500") && (
        <BottomNavigationComponent></BottomNavigationComponent>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      {/* Confirmation Dialog for Attendance Out */}
      <Dialog open={openDialog} onClose={cancelAttendanceOut}>
        <DialogTitle>Confirm Attendance Out</DialogTitle>
        <DialogContent>
          Are you sure you want to mark yourself as "Attendance Out"? This
          action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelAttendanceOut} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmAttendanceOut} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MobileMainComponent;
